import TopBar from "../components/TopBar";
import { Box, Typography, useTheme, styled } from "@mui/material";
import { LineChart } from '@mui/x-charts';
import { tokens } from "../theme";
import { useEffect, useState } from "react";
import Leaderboard from "../components/Leaderboard";

import { fetchTransactions, fetchUsers, fetchQuotes } from "../utils/apiHelpers";
import LoadingBox from "../components/LoadingBox";
import { useInsertionEffect } from "react";

function Statistics() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [loading, setLoading] = useState(true)
  const [transactions, setTransactions] = useState([])
  const [users, setUsers] = useState([])
  const [quotes, setQuotes] = useState([])

  const [baxbollar, setBaxbollar] = useState([])
  const [totalPrice, setTotalPrice] = useState([])
  const [totalTransactions, setTotalTransactions] = useState([])
  const [quoteStats, setQuoteStats] = useState([])

  const [totalAtEachDate, setTotalAtEachDate] = useState([]);

  useEffect(() => {
    Promise.all([fetchTransactions(true), fetchUsers(), fetchQuotes()])
      .then(([transactionsData, usersData, quotesData]) => {
        setTransactions(transactionsData);
        setUsers(usersData);
        setQuotes(quotesData);
        setLoading(false);
      })
      .catch(err => console.log(err));
  }, [])

  useEffect(() => {
    if (!transactions.length || !users.length || !quotes.length) return;

    const userStats = users.map(user => {
      const userTransactions = transactions.filter(t => t.user_name === user.name);
      
      return {
        name: user.display_name,
        pfp: user.profile_image_path,
        baxbollar: userTransactions
          .filter(t => t.product_name === "Baxboll")
          .reduce((total, t) => total + t.amount, 0),
        totalSpent: userTransactions
          .reduce((total, t) => total + (t.amount * t.cost), 0),
        totalTransactions: userTransactions.length
      };
    });

    const userQuoteStats = users.map(user => {
      const userQuotes = quotes.filter(q => q.name === user.name);

      console.log(user.name + " " + userQuotes.length)

      return {
        name: user.display_name,
        pfp: user.profile_image_path,
        quotes: userQuotes.length
      }
    })

    const chronologicalTransactions = transactions.sort((a, b) => new Date(a.date) - new Date(b.date))
    // Calculate running total
    let runningTotal = 0;
    const totalAtEachDate = chronologicalTransactions.reduce((totalToDate, transaction) => {
      runningTotal += transaction.amount * transaction.cost;
      
      // Add new entry to array instead of using object keys
      totalToDate.push({
        date: new Date(transaction.date),
        total: runningTotal
      });
      
      return totalToDate;
    }, []);
    setTotalAtEachDate(totalAtEachDate);

    console.log("Total at each date:", totalAtEachDate);

    setBaxbollar(userStats
      .map(({name, baxbollar, pfp}) => ({name, value: baxbollar, pfp}))
      .sort((a, b) => b.value - a.value)
    );

    setTotalPrice(userStats
      .map(({name, totalSpent, pfp}) => ({name, value: totalSpent, pfp}))
      .sort((a, b) => b.value - a.value)
    );

    setTotalTransactions(userStats
      .map(({name, totalTransactions, pfp}) => ({name, value: totalTransactions, pfp}))
      .sort((a, b) => b.value - a.value)
    );

    setQuoteStats(userQuoteStats
      .map(({name, quotes, pfp}) => ({name, value: quotes, pfp}))
      .sort((a, b) => b.value - a.value))
  }, [transactions, users, quotes]);

  return (
    <div>
      <TopBar/>
      <LoadingBox sx={{m : "30px 0 0 0" }}>
      <Typography
        variant="h2"
        color={colors.ceriseAccent[900]}
        fontWeight="medium" 
        sx={{m : "0 0 10px 30px" }}
        >
        Statistik
      </Typography>
      <Typography
        variant="h3"
        color={colors.gray[100]}
        fontWeight="medium" 
        sx={{m : "0 0 30px 30px" }}
        >
        Topplistor
      </Typography>
      
      {/* Leaderboards */}
      <LeaderboardContainer>
        <LeaderboardBox>
          <Leaderboard name="Baxbollar" stats={baxbollar} suffix="st" colors={colors}/>
        </LeaderboardBox>
        <LeaderboardBox>
          <Leaderboard name="Spenderat" stats={totalPrice} suffix="kr" colors={colors}/>
        </LeaderboardBox>
        <LeaderboardBox>
          <Leaderboard name="Transaktioner" stats={totalTransactions} suffix="st" colors={colors}/>
        </LeaderboardBox>
        <LeaderboardBox>
          <Leaderboard name="Citat" stats={quoteStats} suffix="st" colors={colors}/>
        </LeaderboardBox>
      </LeaderboardContainer>  
      <Typography
        variant="h2"
        color={colors.ceriseAccent[900]}
        fontWeight="medium" 
        sx={{m : "30px 0 30px 30px" }}
        >
        Totalt spenderat
      </Typography>

      {/* Spending over time graph */}
      {
        totalAtEachDate.length && !loading > 0 ? 
        <LineChart
          dataset={totalAtEachDate}
          xAxis={[{ 
            dataKey: 'date',
            scaleType: 'time',
            valueFormatter: (date) => date.toLocaleDateString("sv-SE", {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            })
          }]}
          series={[{ 
            dataKey: 'total', 
            color: colors.ceriseAccent[500],
            valueFormatter: (value) => `${value} kr`
          }]}
          height={300}
          grid={{ vertical: true, horizontal: true }}
          slotProps={{
            legend: {
              hidden: true
            },
            tooltip: {
              sx: {
                backgroundColor: colors.gray[700],
                borderRadius: '3px',
                border: `1px solid ${colors.ceriseAccent[500]}`,
                '& .MuiMarkdown-root': {
                  color: colors.ceriseAccent[100]
                },
                '& .MuiTypography-root': {
                  color: colors.gray[100]
                },
                '& .MuiChartsTooltip-table': {
                  color: colors.gray[100]
                }
              }
            }
          }}
        />
        :
        <Typography
          variant="h3"
          color={colors.gray[400]}
          fontWeight="regular" 
          sx={{m : "0px 0 30px 0" }}
          >
          Inga transaktioner än...
        </Typography>
      }
      </LoadingBox>
    </div>
  )
}

const LeaderboardContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-around",
  flex: 1,
  flexWrap: "wrap",
  margin: "0px 10px 10px 10px"
});

const LeaderboardBox = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "45%",
  padding: "10px",
  borderRadius: "3px",
  margin: "0 0 10px 0",
  backgroundColor: tokens(theme.palette.mode).gray[700]
}));

export default Statistics;